import type { DashDeviceCardConfig, DashDeviceControlPlacement } from './dash-types';

/** Normalize Control-card placement. Missing / unknown → whole-card tap (`card`). */
export const normalizeDeviceCardConfig = (
	config?: DashDeviceCardConfig | null,
): { controlPlacement: DashDeviceControlPlacement } => ({
	controlPlacement: config?.controlPlacement === 'button' ? 'button' : 'card',
});
